const DAY_MS = 24 * 60 * 60 * 1000;

export function getSubscriptionEndDate(subscription) {
  const safeSubscription = subscription || {};
  const status = String(safeSubscription.status || "").toLowerCase();

  // Stripe behält trial_end auch nach einer abgeschlossenen Testphase als historisches
  // Datum. Für aktive Abos ist deshalb nur das Ende der laufenden Periode maßgeblich.
  const rawEndDate = status === "trial" || status === "trialing"
    ? safeSubscription.trial_ends_at
    : safeSubscription.current_period_end;
  if (!rawEndDate) return null;

  const endDate = new Date(rawEndDate);
  return Number.isNaN(endDate.getTime()) ? null : endDate;
}

export function getSubscriptionDaysRemaining(subscription, now = Date.now()) {
  const endDate = getSubscriptionEndDate(subscription);
  if (!endDate) return null;

  const nowMs = now instanceof Date ? now.getTime() : Number(now);
  if (!Number.isFinite(nowMs)) return null;
  return Math.max(0, Math.ceil((endDate.getTime() - nowMs) / DAY_MS));
}
